export const CLEAR_ALL_BALANCES = 'CLEAR_ALL_BALANCES';
export const SET_TOKEN_BALANCE = 'SET_TOKEN_BALANCE';
